<template>
  <div
    :class="{
      'filter-option--selected': selected,
    }"
    class="filter-option"
    @click="$emit('click')"
  >
    <template v-if="showLocationIcons">
      <Map
        v-if="isRegion"
        class="shrink-0 text-stone-500"
        :size="20"
        aria-hidden="true"
      />
      <MapPin
        v-else
        class="shrink-0 text-stone-500"
        :size="20"
        aria-hidden="true"
      />
    </template>
    <div class="filter-option__label">{{ label }}</div>
    <div
      v-if="count != null && count !== undefined"
      class="filter-option__count text-xs text-gray-500"
    >
      {{ count }}
    </div>
  </div>
</template>
<script setup lang="ts">
import { Map, MapPin } from 'lucide-vue-next'

defineEmits(['click'])

const {
  label = undefined,
  count = undefined,
  selected = false,
  showLocationIcons = false,
  isRegion = false,
} = defineProps<{
  label?: string
  count?: number
  selected?: boolean
  /** Map / MapPin for city & region rows; categories omit icons */
  showLocationIcons?: boolean
  /** Folded map vs pin when `showLocationIcons` (Algolia `type: region`) */
  isRegion?: boolean
}>()
</script>

<style lang="postcss" scoped>
.filter-option {
  @apply flex items-center gap-3 py-3.5 px-1 rounded-lg border-0 shadow-none cursor-pointer ease-in-out duration-150;

  &__label {
    @apply flex-1 min-w-0 text-sm font-normal text-gray-900 leading-snug;
  }

  &__count {
    @apply shrink-0 hidden;
  }

  &.filter-option--selected {
    @apply bg-teal-50 text-teal-900;

    .filter-option__label {
      @apply text-teal-900 font-medium;
    }
  }

  &:hover:not(.filter-option--selected) {
    @apply bg-teal-50;
  }
}
</style>
